import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import CustomModal from './CustomModal'
import Newsletter from 'src/pages/Newsletter'
import { handleUrl } from 'src/lib/utils'
function Footer() {
  const data = useSelector((state) => state.generalData)
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <section className="bottom-wrapper mt-auto">
        <div className="container custom-container-one">
          <div className="row">
            <div className="col-lg-11 offset-lg-1">
              <div className="bottom-links">
                <Link to={handleUrl()} className="steps-name">
                  {data.txt_forclient}
                </Link>
                <Link to="/forattorney" className="steps-name">
                  {data.txt_forattoneys}
                </Link>
                <Link to="/forfamily" className="steps-name">
                  {data.txt_forfamilyandsupporters}
                </Link>
                <Link to="/forprofessionals" className="steps-name">
                  {data.txt_formentalhealth}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="footer">
        <div className="container custom-container">
          <div className="col-lg-12" style={{ paddingBottom: '14px' }}>
            <ul className="row row-cols-1 row-cols-lg-3 g-1 g-lg-1">
              <li className="col-lg-2">
                <Link to="/feedback">{data.txt_Feedback}</Link>
              </li>
              <li className="col-lg-2">
                <Link to="/podcasts">{data.txt_podcastlinktext}</Link>
              </li>
              <li className="col-lg-3">
                <Link to="/about">{data.txt_aboutus}</Link>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Link to="/privacypolicy">{data.txt_privacypolicy}</Link>
              </li>
              <li className="col-lg-2">
                <Link to="/termsofuse">{data.txt_termsofuse}</Link>
              </li>
              <li className="col-lg-2">
                <Link to="/contactus">{data.txt_contactus}</Link>
              </li>
              <li className="col-lg-1">
                <Link
                  to="#"
                  className="nav-link active"
                  data-target="#newsletterModal"
                  data-toggle="modal"
                  onClick={() => setShowModal(true)}
                >
                  {data.txt_newsletterlink}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <CustomModal
        show={showModal}
        onHide={() => setShowModal(false)}
        bodyContent={<Newsletter onClose={() => setShowModal(false)} />}
        size={'lg'}
      />
    </>
  )
}

export default Footer
